// @flow

// !!! IMPORTANT !!!
//
// This file is shared between the zapier/zapier and zapier/next-js repository.
// Any changes made here should be reflected in there as well.
// For more information, see: https://zapier.quip.com/xaKqAOpdhpY2#ZXFACA8Jnp9

/*
 * Wrap a component along with a media query (or queries). If a media query
 * changes, re-render the component. Pass in an object of strings, and the
 * wrapped component will get a `matchesMediaQuery` prop with an object of
 * booleans.
 */

import PropTypes from 'prop-types';
import React from 'react';
import createReactClass from 'create-react-class'; // eslint-disable-line no-restricted-syntax
import { get, isEqual, omit } from 'lodash';

import { hocify } from '@zapier/legacy-components';
import { isBrowser } from '@zapier/common-utils';

type MediaQueryLists = {
  [string]: {
    [string]: (fn: any) => {},
  },
};

export const MatchesMediaQuery = createReactClass({
  displayName: 'MatchesMediaQuery',
  mediaQueryLists: (null: ?MediaQueryLists),

  propTypes: {
    Component: PropTypes.func.isRequired,
    mediaQueries: PropTypes.object.isRequired,
  },

  getInitialState() {
    return {
      matchesMediaQuery: {},
    };
  },

  componentDidMount() {
    this.configureMediaQueries(this.props.mediaQueries);
  },

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!isEqual(this.props.mediaQueries, nextProps.mediaQueries)) {
      this.configureMediaQueries(nextProps.mediaQueries);
    }
  },

  componentWillUnmount() {
    this.bindMediaQueryListeners(false);
    this.mediaQueryLists = null;
  },

  configureMediaQueries(mediaQueries) {
    if (isBrowser()) {
      this.bindMediaQueryListeners(false);
      this.buildMediaQueryLists(mediaQueries);
      this.bindMediaQueryListeners(true);
      this.setMatchesState();
    }
  },

  buildMediaQueryLists(mediaQueries) {
    this.mediaQueryLists = Object.keys(mediaQueries).reduce(
      (lists, key) => ({
        [key]: window.matchMedia(mediaQueries[key]),
        ...lists,
      }),
      {}
    );
  },

  bindMediaQueryListeners(shouldBind) {
    const { mediaQueryLists } = this;
    const method = shouldBind ? 'addListener' : 'removeListener';
    Object.keys(mediaQueryLists || {}).forEach(key => {
      const mediaQuery = get(mediaQueryLists, key);
      const methodFn = get(mediaQuery, method);
      if (mediaQuery && methodFn) {
        methodFn.call(mediaQuery, this.onChangeMediaQuery);
      }
    });
  },

  onChangeMediaQuery() {
    this.setMatchesState();
  },

  setMatchesState() {
    const { mediaQueryLists } = this;
    if (!mediaQueryLists) {
      return;
    }

    const matchesMediaQuery = Object.keys(mediaQueryLists).reduce(
      (result, key) => ({
        [key]: mediaQueryLists[key].matches,
        ...result,
      }),
      {}
    );
    this.setState({ matchesMediaQuery });
  },

  render() {
    const { Component, ...props } = this.props;
    const childProps = omit(props, 'mediaQueries');
    return <Component {...childProps} {...this.state} />;
  },
});

const matchesMediaQuery = (mediaQueries: Object) =>
  hocify(MatchesMediaQuery, { mediaQueries });

export default matchesMediaQuery;
